module.exports = __webpack_public_path__ + "static/media/selec-nft-4.0cb07770.png";